<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content fxLayout="column" fxLayoutAlign="start">
    <mat-horizontal-stepper [linear]="true" class="pt-16" labelPosition="bottom" #stepper (selectionChange)="onStepChange($event)">
        <mat-step [completed]="!!list.length">
            <ng-template matStepLabel>{{ 'GENERAL.LABEL.PARTICIPANTS' | translate }}</ng-template>

            <ng-container *ngIf="list.length">
                <h3 class="mb-8 text-base font-medium text-gray-600">{{ 'GENERAL.LABEL.SELECTED_USERS' | translate }}</h3>
                <mat-chip-set class="chip-list wrap mb-16">
                    <mat-chip class="chip maxbrain-500" [removable]="removable" (removed)="removeFromList(item)" *ngFor="let item of list">
                        {{ item.fullName }}
                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                    </mat-chip>
                </mat-chip-set>
            </ng-container>

            <div fxLayout="row" fxLayoutAlign="flex-end center" class="mb-12">
                <app-search-outline [searchInput]="searchInput"></app-search-outline>
            </div>

            <div class="w-100-p table-wrapper" *ngIf="dataSource">
                <mat-table #table [dataSource]="dataSource" matSort>
                    <!-- Avatar Column -->
                    <ng-container matColumnDef="avatar">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            <div class="relative" #avatarCell>
                                <img class="avatar" *ngIf="user?.avatar.src; else initials" [alt]="user.fullName" [src]="user.avatar.src" />
                                <ng-template #initials>
                                    <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                                </ng-template>
                                <ng-template [onlineStateIndicator]="user.isOnline"> </ng-template>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <!-- First Name Column -->
                    <ng-container matColumnDef="firstName">
                        <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header> {{ 'GENERAL.PROPERTY.FIRST_NAME' | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let user" class="narrow">
                            <p #firstNameRow class="text-truncate font-semibold">
                                {{ user.firstName }}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <!-- Last Name Column -->
                    <ng-container matColumnDef="lastName">
                        <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header>
                            {{ 'GENERAL.PROPERTY.LAST_NAME' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let user" class="narrow">
                            <p #lastNameRow class="text-truncate font-semibold">
                                {{ user.lastName }}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <!-- Email Column -->
                    <ng-container matColumnDef="email">
                        <mat-header-cell class="wider" *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs>
                            {{ 'GENERAL.PROPERTY.EMAIL' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let user" fxHide fxShow.gt-xs>
                            <p #lastNameRow class="text-truncate font-semibold">{{ user.email }}</p>
                        </mat-cell>
                    </ng-container>

                    <!-- Buttons Column -->
                    <ng-container matColumnDef="buttons">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            <div fxFlex="row" fxLayoutAlign="end center">
                                <app-flat-button [label]="'GENERAL.BUTTON.ADD'" (onClick)="addToList(user)" *ngIf="!user.alreadyMember && !user.selected"></app-flat-button>
                                <p *ngIf="user.alreadyMember">{{ 'GENERAL.LABEL.IN_GROUP' | translate }}</p>
                                <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(user)" *ngIf="user.selected"></app-white-button>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let user; columns: displayedColumns" class="user" matRipple> </mat-row>
                </mat-table>
                <mat-paginator persistPageSize="module-managers.add-program-managers-dialog" [length]="totalCount$ | async" [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 50]"> </mat-paginator>
            </div>
        </mat-step>

        <mat-step>
            <ng-template matStepLabel> {{ 'GENERAL.LABEL.MANAGER_PERMISSIONS' | translate }}</ng-template>
            <div class="p-24 bg-zinc-50 rounded">
                <div fxLayout="row wrap" fxLayoutGap="16px">
                    <div fxFlex="1 0 calc(50% - 16px)" *ngFor="let managerPermission of moduleManagerPermissions.all; let i = index">
                        <mat-checkbox [formControl]="permissionsFormArray.at(i)" [class.mb-16]="managerPermission.description">
                            <div fxLayout="column" class="ml-8">
                                <h3 class="text-sm font-semibold my-0">{{ managerPermission.title | translate }}</h3>
                                <p class="text-sm font-light mt-4 mb-0" *ngIf="managerPermission.description">{{ managerPermission.description | translate }}</p>
                            </div>
                        </mat-checkbox>
                    </div>
                </div>
            </div>
        </mat-step>

        <mat-step>
            <ng-template matStepLabel> {{ 'GENERAL.LABEL.EXECUTIONS' | translate }}</ng-template>

            <div *ngIf="programStructuresWithGroups.length; else noProgramStructure">
                <div *ngFor="let programStructureWithGroup of programStructuresWithGroups; let i = index; let isLast = last" [class.mb-16]="!isLast">
                    <h2 class="mb-16">{{ programStructureWithGroup.group.name }}</h2>

                    <div class="p-16 bg-zinc-50">
                        <div
                            fxLayout="row"
                            fxLayoutAlign="flex-start center"
                            class="w-100-p p-16 pb-0 bg-white"
                            *ngFor="let defaultExecutionWithCourseOffering of programStructureWithGroup.structure; let j = index; let isLastExecution = last"
                            [class.mb-8]="!isLastExecution"
                        >
                            <div
                                fxLayout="row"
                                fxLayoutAlign="flex-start center"
                                class="pb-16"
                                *ngIf="
                                    defaultExecutionWithCourseOffering.courseOffering.courseTemplate.kind === ModuleKind.ProgramExecution ||
                                        defaultExecutionWithCourseOffering.courseOffering.courseTemplate.kind === ModuleKind.ProgramTemplate;
                                    else selectRelevantExecution
                                "
                            >
                                <mat-icon class="mr-16" [svgIcon]="defaultExecutionWithCourseOffering.courseOffering.courseTemplate | getModuleIcon"> </mat-icon>

                                <div fxLayout="column">
                                    <h3 class="text-gray-400">{{ defaultExecutionWithCourseOffering.courseOffering.name }}</h3>
                                    <p class="text-gray-400">{{ 'PAGE.DIALOG.ADD_PROGRAM_MANAGERS.LABEL.BOOK_TO_PROGRAM' | translate }}</p>
                                </div>
                            </div>

                            <ng-template #selectRelevantExecution>
                                <mat-icon class="mr-16 mb-24" [svgIcon]="defaultExecutionWithCourseOffering.courseOffering.courseTemplate | getModuleIcon"> </mat-icon>

                                <mat-form-field class="w-100-p">
                                    <mat-label>{{ defaultExecutionWithCourseOffering.courseOffering.name }}</mat-label>
                                    <mat-select [formControl]="getFormControl(i, j)" (openedChange)="onFormControlClick(i, j, $event)">
                                        <mat-option [value]="null">{{ 'GENERAL.LABEL.NOT_SELECTED' | translate }}</mat-option>
                                        <mat-option *ngFor="let option of defaultExecutionWithCourseOffering.options" [value]="option.id">
                                            <div fxFlex="row" fxLayoutAlign="start space-between">
                                                <div fxFlex="column" fxLayoutAlign="start center">
                                                    <span>{{ option.name }}</span>
                                                    <span>&nbsp;</span>
                                                    <span class="text-gray-400 text-xs">
                                                        ({{
                                                            option.version
                                                                ? option.version
                                                                : option.startDate
                                                                ? (option.startDate | date: 'shortDate') + ' - ' + (option.endDate | date: 'shortDate')
                                                                : '-'
                                                        }})
                                                    </span>
                                                </div>
                                                <div *ngIf="option.isDefault">
                                                    <span class="bg-primary-50 rounded-full px-16 py-8 mr-12 text-sm text-primary-600 font-medium">
                                                        {{ 'PAGE.DIALOG.EDIT_RELEVANT_EXECUTIONS.LABEL.DEFAULT_EXECUTION' | translate }}
                                                    </span>
                                                </div>
                                            </div>
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>

            <ng-template #noProgramStructure>
                <div fxLayout="column" fxLayoutAlign="center center" class="no-progress-container p-32">
                    <mat-icon class="participant-view-illustration" svgIcon="program_structure_illustration"></mat-icon>
                    <h3 class="mt-8 mb-4 text-2xl font-medium">
                        {{ 'GENERAL.LABEL.NO_PROGRAM_STRUCTURE' | translate }}
                    </h3>
                    <p class="mt-0 mb-16 text-base font-normal">
                        {{ 'PAGE.DIALOG.ADD_PROGRAM_PARTICIPANTS.LABEL.NO_PROGRAM_STRUCTURE' | translate }}
                    </p>
                </div>
            </ng-template>
        </mat-step>
    </mat-horizontal-stepper>
</div>

<div mat-dialog-actions class="pt-0 action-buttons" fxLayout="row" fxLayoutAlign="space-between center">
    <app-white-button *ngIf="shouldShowBookManagersButton" [label]="'PROGRAM_STRUCTURE.BUTTON.EDIT_PROGRAM_STRUCTURE'" (onClick)="editProgramStructure()"></app-white-button>

    <div fxLayout="row" fxLayoutAlign="end center" class="w-100-p">
        <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

        <app-flat-button *ngIf="shouldShowNextButton" [label]="'GENERAL.BUTTON.NEXT'" class="mr-8" [disabled]="!list.length" (onClick)="goForward(stepper)"></app-flat-button>

        <app-flat-button
            *ngIf="shouldShowBookManagersButton"
            [label]="'PAGE.DIALOG.ADD_PROGRAM_MANAGERS.LABEL.BOOK_MANAGERS' | translate: { participantsCount: list.length, executionsCount: selectedExecutionIds.length }"
            class="mr-8"
            [disabled]="!list.length"
            (onClick)="saveSelected(stepper)"
        ></app-flat-button>
    </div>
</div>
